import { EAnalyticsConstant } from "../../../constants/analytics";
import { withBlockPayment, ymPushParams } from "../../../utils/ym";
export var onPaymentModalSuccessAnalyticsHandler = function onPaymentModalSuccessAnalyticsHandler(sum) {
  ymPushParams(withBlockPayment({
    sberpay: {
      success: sum
    }
  }));
};
export var onPaymentModalErrorAnalyticsHandler = function onPaymentModalErrorAnalyticsHandler() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EAnalyticsConstant.Error;
  ymPushParams(withBlockPayment({
    sberpay: {
      error: error
    }
  }));
};